import axiosInstance from '../app/axios';

export const homeAPI = {
  getFeatured: async () => {
    const response = await axiosInstance.get('/home/featured');
    return response.data;
  },
  getOnSale: async () => {
    const response = await axiosInstance.get('/home/on-sale');
    return response.data;
  },
  getBestSellers: async () => {
    const response = await axiosInstance.get('/home/best-sellers');
    return response.data;
  },
  getNewArrivals: async () => {
    const response = await axiosInstance.get('/home/new-arrivals');
    return response.data;
  },
  getMostViewed: async () => {
    const response = await axiosInstance.get('/home/most-viewed');
    return response.data;
  },
  getCategories: async () => {
    const response = await axiosInstance.get('/home/categories');
    return response.data;
  },
  getCategoryItems: async (slug) => {
    const response = await axiosInstance.get(`/home/categories/${slug}`);
    return response.data;
  },
};

export default homeAPI;
